import {
  FormField,
  FormGrid,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
} from '@dixa/lib-shared-habla';
import { HookFormTextarea } from 'lib-shared-hook-form';
import { useForm } from 'react-hook-form';

import { createAppModal } from 'utils/modal';

import styles from './sidekickAskModal.module.scss';

type FieldValues = {
  answer: string;
};

/**
 * Asks the user for context before a prompt is sent to the Sidekick. The answer
 * is optional, so confirming an empty field is a valid way through.
 */
export const SidekickAskModal = createAppModal(
  { type: 'app:sidekickAsk' },
  ({ isOpen, modal, meta, hide }): JSX.Element => {
    const form = useForm<FieldValues>({ defaultValues: { answer: '' } });

    const handleCancel = () => {
      hide();
      meta?.resolve({ isCancelled: true });
    };

    const handleConfirm = ({ answer }: FieldValues) => {
      hide();
      meta?.resolve({ answer: answer.trim() });
    };

    return (
      <Modal isOpen={isOpen} onClose={handleCancel} className={styles.modal}>
        <ModalHead title={modal.arg.title} onClose={handleCancel} />

        <ModalBody>
          <FormGrid>
            <FormField>
              <HookFormTextarea
                name="answer"
                label={modal.arg.label}
                control={form.control}
                componentProps={{
                  placeholder: modal.arg.placeholder,
                  autoFocus: true,
                  height: 96,
                }}
              />
            </FormField>
          </FormGrid>
        </ModalBody>

        <ModalFoot
          cancelOnClick={handleCancel}
          confirmName="Ask Sidekick"
          confirmOnClick={form.handleSubmit(handleConfirm)}
        />
      </Modal>
    );
  },
);
